import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { provideLocationState } from "components/utility/hoc/LocationState";

const OwlShopActions = require("lib/actions/OwlShopActions");
const OwlShopSelectors = require("lib/selectors/OwlShopSelectors");

var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");
var LoadingButton = require("components/utility/LoadingButton");
var Owlvatar = require("components/avatars/Owlvatar");
var StudentAvatar = require("components/avatars/StudentAvatar");
var OwlShopPatcher = require("components/avatars/OwlShopPatcher");

var OwlShopRouting = require("lib/routing/OwlShopRouting");

require("games/dressing_room.scss");

function studentPropsToConditions(props) {
	var conditions = {}
	if (props.student) {
		conditions = { userID: props.student.id }
	}
	return conditions
}

@connect(
	(state, ownProps) => ({
		filteredPatches: OwlShopSelectors.getFilteredPatches({ state }),
		user: ownProps.student || CurrentUser.get()
	}),
	(dispatch, props) => ({
		populateData: () => {
			return dispatch(OwlShopActions.fetchPatches({ conditions: studentPropsToConditions(props) }))
		},
		updateAvatar: ({ id, update, embeds, query }) =>
			dispatch(OwlShopActions.updateAvatar({ id, update, embeds, query })),
		updateCurrentUser: (callback) => CurrentUser.fetchCurrentUserData(callback),
		fetchPerks: ()=> dispatch(OwlShopActions.fetchPerks()),
		fetchPatches: () => {
			return dispatch(OwlShopActions.fetchPatches({ conditions: studentPropsToConditions(props) }))
		}
	}),
)

@providePopulateData()
class DressingRoom extends React.Component {

	constructor(props) {
		super();
		autobind(this);

		var startPatchType = this.hideOwls(props.user) ? null : "head";

		var avatar = props.user.avatar;

		this.state = {
			equippedPatches: avatar.patches,
			colors: avatar.colors,
			previewItemName: null,
			previewItemType: null,
			loading: false,
			allFurnitures: [],
			activePatchType: startPatchType,
		};
	}

	hideOwls = (user) => user && user.settings && user.settings.hide_owls;

	renderOwlvatar() {
		if (this.hideOwls(this.props.user)) {
			return <StudentAvatar student={this.props.user} maxWidth={100} />;
		}
		var patches = {};
		var previewPatch = this.getPreviewItem();

		_.each(
			this.state.equippedPatches,
			function(patch, patchType) {
				if (
					previewPatch &&
					patchType == this.state.previewItemType &&
					previewPatch.tier <= this.props.user.tier + 1
				) {
					patches[patchType] = previewPatch;
				} else {
					patches[patchType] = patch;
				}
			}.bind(this),
		);
		return (
			<div className="owlvatar">
				<Owlvatar patches={patches} colors={this.state.colors} maxWidth={250} />;
			</div>
		)
	}

	getPreviewItem() {
		return _.find(
			this.props.filteredPatches,
			function(patch) {
				return (
					patch.name == this.state.previewItemName &&
					patch.patch_type == this.state.activePatchType
				);
			}.bind(this),
		);
	}

	setActiveType(pType) {
		this.setState({ activePatchType: pType });
	}
	
	setEquippedPatches(patches) {
		this.setState({ equippedPatches: patches });
	}

	setPreviewItem(name, type) {
		this.setState({ previewItemName: name, previewItemType: type });
	}

	renderShelf() {
		var rowBackgroundPath = require("tiers/trophy-shelf-1.png");
		return (
			<div className="shelf">
				<img src={ rowBackgroundPath } className="shelfBackground"/>
				<img src={ rowBackgroundPath } className="shelfBackground"/>
			</div>
		)
	}

	requiresSave() {
		if (this.props.user == undefined) {
			return false;
		}
		var oldAvatar = this.props.user.avatar;
		var updated = false;

		_.each(this.state.equippedPatches, function(patch, patchType) {
			if (patch.name != oldAvatar.patches[patchType].name) {
				updated = true;
			}
		});

		_.each(
			oldAvatar.patches,
			function(patch, patchType) {
				if (
					this.state.equippedPatches[patchType] == undefined ||
					patch.name != this.state.equippedPatches[patchType].name
				) {
					updated = true;
				}
			}.bind(this),
		);

		_.each(this.state.colors, function(color, patchType) {
			if (color != oldAvatar.colors[patchType]) {
				updated = true;
			}
		});

		return updated;
	}

	handleAvatarUpdated = avatar => {
		if(avatar.errors) this.notifyErrors(avatar.errors);
		else {
			this.notifyAvatarSaved();
			this.props.updateCurrentUser(
				()=>this.forceUpdate()
			);
			Mycroft.newEvent({ category: "Owl Shop", action: "save-avatar" });
		}
	}


	saveAvatar() {
		var avatarData = {
			patches: this.state.equippedPatches,
			colors: this.state.colors,
		};
		var avatarID = this.props.user.avatar.id;
		this.setState({ loading: true });

		this.props.updateAvatar({id: avatarID,update:{...avatarData}}).then(
			result=>{
				this.setState({loading:false});
				this.handleAvatarUpdated (result.avatar)
			}
		)
	}

	notifyErrors = errors => window.wrNotifications.triggerDropDownNotification({
		title: "Sorry!",
		text: errors.join(", "),
		icon: "exclamation-sign",
		type: "error",
	});

	notifyAvatarSaved = () => window.wrNotifications.triggerDropDownNotification({
		title: "Great!",
		text: "Your Owlvatar has been saved!",
		icon: "ok-sign",
	});


	render() {
		var student = this.props.student
		var shouldHideOwls = this.hideOwls(this.props.user);
		var previewOwl = this.renderOwlvatar();

		if (this.requiresSave()) {
			var saveButton = (
				<LoadingButton
					onClick={this.saveAvatar}
					loading={this.state.loading}
					className="btn buttonSuccess saveButton"
					text="Save"
				/>
			);
		}

		if (student.perks.houses != "") {
			var backgroundPath = require("perks/houses/" +
				student.perks.houses
					.toLowerCase()
					.replace(/ /g, "-")
					.replace("'", "") +
				"-empty.png");
		}

		return (
			<div className="dressingRoom">
				<img src={ backgroundPath } className="modalBackground"/>
				<div className="owlvatarControl"> 
					{ previewOwl }
					{ saveButton }
				</div>     
				<div className="dressingPatcher"> 
					<OwlShopPatcher
						mode="dressing"
						equippedPatches={this.state.equippedPatches}
						colors={this.state.colors}
						previewItemName={this.state.previewItemName}
						activePatchType={this.state.activePatchType}
						activeOtherType={this.state.activeOtherType}
						hideOwls={shouldHideOwls}
						setEquippedPatches={this.setEquippedPatches}
						setColors={this.setColors}
						setPreviewItem={this.setPreviewItem}
						setActiveType={this.setActiveType}
						updateCurrentUser={this.props.updateCurrentUser}
						fetchPerks={this.props.fetchPerks}
						fetchPatches={this.props.fetchPatches}
						beginAtTier={false}
					/>
				</div>
			</div>
		);
	}
}


module.exports = DressingRoom


// WEBPACK FOOTER //
// ./modules/components/games/DressingRoom.js